module.exports = "https://img.zhijierongxing.com/saas/img/de_icon5.64153f13.png";